import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../../contexts/SessionContext';
import API_URL from '../../constants/environment';
import {
    CreateInventoryBinInput,
    CreateInventoryBinResponse,
} from '../../types/inventory';

const createInventoryBin = async (
    sessionId: string,
    input: CreateInventoryBinInput,
): Promise<CreateInventoryBinResponse> => {
    const { data } = await axios.post(`${API_URL}/inventory/bins/create`, input, {
        headers: { Authorization: sessionId },
    });
    return data;
};

export const useCreateInventoryBin = (
    options?: UseMutationOptions<
        CreateInventoryBinResponse,
        unknown,
        CreateInventoryBinInput
    >,
) => {
    const sessionContext = useContext(SessionContext);

    return useMutation({
        mutationFn: (input: CreateInventoryBinInput) =>
            createInventoryBin(sessionContext?.sessionId ?? '', input),
        ...options,
    });
};
